import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Button = props =>
  <div className="mb-3 d-grid">
    <button className="btn btn-primary" disabled={props.loading}>
      {(() => {
        if (props.loading) return (
          <span>
            <FontAwesomeIcon icon="cog" spin className="me-1" />
            {(() => {
              switch (props.action) {
                case props.urls.signinup: return 'Loading...'
                case props.urls.signin: return 'Signing In...'
                case props.urls.signup: return 'Signing Up...'
              }
            })()}
          </span>
        )

        switch (props.action) {
          case props.urls.signinup: return 'Continue'
          case props.urls.signin: return 'Sign In'
          case props.urls.signup: return 'Sign Up'
        }
      })()}
    </button>
  </div>

export default Button
